export default __webpack_public_path__ + "static/media/jungleGYm logo2.5876f1ae.png";